const AuditTrail = (props) => {
    return(
        <>
            at
        </>
    )
}

export default AuditTrail